import axiosPost from "../axiosPost";

export const zonaUpd = async ({
    gateZonaId,
    gateZonaCod,
    gateZonaNombre,
    gateZonaGlobal,
    gateZonaVersion
}, credentials) => {
    const body = {
        service: "GateZonaUpd",
        params: {
            gateZonaId,
            gateZonaCod,
            gateZonaNombre,
            gateZonaGlobal,
            gateZonaVersion,
        },
    };

    return await axiosPost(body, credentials);
};
